module.exports = __webpack_public_path__ + "img/ltkworkwear-2x.1dbc976.jpg";